import { ShootTypeSchema } from "@redotech/redo-inventory-common/image-generation";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import * as z from "zod";

export const startImageOptimization = {
  name: "startImageOptimization" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    productId: productIdFormat.schema.optional(),
    sourceImageUrls: z.array(z.string()).min(1),
    shootType: ShootTypeSchema.optional(),
  }),
  output: z.object({ workflowId: z.string() }),
};
